import styled from "styled-components";

export const InsideError = styled.div`
    margin-top: 90px;
    padding-bottom: 150px;
`